import React, { useState } from 'react';
import { AtSign, Save } from 'lucide-react';
import { api, errMsg } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { toast } from 'sonner';

export const CustomerUsername = ({ username, onSaved }) => {
  const { user, setUser } = useAuth();
  const [draft, setDraft] = useState(null);
  const [credential, setCredential] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async event => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError('');
    try {
      const { data } = await api.put('/portal/username', { username: (draft ?? username ?? '').trim(), credential });
      setCredential(''); setDraft(data.username);
      setUser(value => value?.id === user?.id ? { ...value, username: data.username } : value);
      await onSaved(); toast.success('Username saved');
    } catch (failure) { setCredential(''); setError(errMsg(failure)); }
    finally { setBusy(false); }
  };
  return <section data-testid="profile-username-section" className="customer-profile-section">
    <h2 data-testid="profile-username-heading" className="customer-section-title flex gap-2 items-center"><AtSign size={18} className="customer-gold" />Username</h2>
    <form data-testid="profile-username-form" onSubmit={save} className="space-y-4 mt-5">
      <div className="space-y-2"><Label htmlFor="profile-username-input">Username</Label><Input id="profile-username-input" data-testid="profile-username-input" value={draft ?? username ?? ''} onChange={event => setDraft(event.target.value)} minLength={3} maxLength={32} pattern="[A-Za-z][A-Za-z0-9._\-]{2,31}" autoComplete="username" autoCapitalize="none" spellCheck={false} required disabled={busy} aria-describedby="profile-username-rules" />
        <p id="profile-username-rules" data-testid="profile-username-rules" className="text-xs customer-muted leading-6">Use 3–32 characters: start with a letter, then letters, numbers, dots, underscores or hyphens</p></div>
      <div className="space-y-2"><Label htmlFor="profile-username-credential">Current PIN or password</Label><Input id="profile-username-credential" data-testid="profile-username-credential" type="password" value={credential} onChange={event => setCredential(event.target.value)} autoComplete="current-password" maxLength={1024} required disabled={busy} /></div>
      {error && <p data-testid="profile-username-error" role="alert" className="customer-alert">{error}</p>}
      <Button data-testid="profile-username-save" type="submit" disabled={busy} className="customer-primary h-11"><Save size={16} className="mr-2" />{busy ? 'Saving…' : 'Save username'}</Button>
    </form>
  </section>;
};